import {
	closeModal,
} from 'show-modal.mod';

export function handleCloseModal() {
	closeModal();
}
